const { uniqueId } = require("lodash");

const { flex } = window;
const { React } = flex.lib;

function PartnerLogo(props) {
    const logoList = props.logoList;

    return (
        <div className='fusion-landing__power-by__content'>
            {logoList.map((logo) => (
                <a href={logo.href} className='fusion-landing__power-by__logo' key={uniqueId()}>
                    <img src={logo.src} alt={logo.alt} />
                </a>
            ))}
        </div>
    );
}

module.exports = PartnerLogo;
